import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import JobsTable from "../components/job/JobsTable";
import PageContainer from "../components/shared/PageContainer";
import { useAutoUpdate } from "../contexts/AutoUpdateContext";
import * as Objects from "../services/api";

const parseSearchParams = (searchParams: URLSearchParams): Record<string, string | string[]> => {
  return Array.from(searchParams.keys()).reduce<Record<string, string | string[]>>((result, paramKey) => {
    const allValues = searchParams.getAll(paramKey);
    result[paramKey] = allValues.length > 1 ? allValues : allValues[0];
    return result;
  }, {});
};

const Jobs: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [jobs, setJobs] = useState<Objects.Job[]>([]);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [availableSets, setAvailableSets] = useState<Objects.TemplateSetAggregate[]>([]);
  const autoUpdate = useAutoUpdate();

  const fetchData = useCallback(() => {
    const defaultParams = { page: 1, limit: 25 };
    const queryParams = { ...defaultParams, ...parseSearchParams(searchParams) };
    Objects.Jobs.list(queryParams).then((result) => {
      setJobs(result.items);
      setTotalRows(result.count);
    });
  }, [searchParams]);

  useEffect(() => {
    Objects.TemplateSets.list().then(setAvailableSets);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    let intervalId = autoUpdate.active ? setInterval(fetchData, 5000) : null;
    return () => (intervalId ? clearInterval(intervalId) : undefined);
  }, [fetchData, autoUpdate.active]);

  return (
    <>
      <PageContainer>
        <JobsTable jobs={jobs} totalRows={totalRows} availableSets={availableSets} />
      </PageContainer>
    </>
  );
};

export default Jobs;

export { parseSearchParams };
